export const getTitle = ({
  title,
  isImageTool,
}: {
  title?: string;
  isImageTool: boolean;
}): string => {
  if (title) {
    return title;
  }

  return isImageTool ? 'Improve image' : 'Prompt shortcuts';
};
